const MONTH_LOCALE: { [key: number]: string } = {
  0: 'января',
  1: 'февраля',
  2: 'марта',
  3: 'апреля',
  4: 'мая',
  5: 'июня',
  6: 'июля',
  7: 'августа',
  8: 'сентября',
  9: 'октября',
  10: 'ноября',
  11: 'декабря',
};

/**
 * генерим нужную строку для даты
 * т.к. стандартные методы объекта Date возвращают строку не в том формате, что нужно
 * и работают некорректно в тестах
 */
export function formatDate(date: string) {
  const dateClass = new Date(date);

  if (dateClass.toString() === 'Invalid Date') {
    return '';
  }

  return `${dateClass.getDate()} ${MONTH_LOCALE[dateClass.getMonth()]} ${dateClass.getFullYear()}`;
}
